var map = {
	"./change1.svg": "0uui",
	"./change2.svg": "Bela"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YU5i";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search ^\.\/change.*\.svg$
// module id = YU5i
// module chunks = 0